import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  // Pulls the shared ItemHeader out to the page gutter so the arrow sits left of the content
  // rather than inside it.
  //
  // This used to cite PoliciesFormBackButton.styles.ts as its precedent. That file — and five
  // sibling back-button wrappers — turned out to be dead code: defined, never imported,
  // never rendered. They have been deleted, so there is no precedent to mirror and the
  // offset stands on its own.
  backHeader: {
    marginLeft: -65,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
    // ItemHeader renders a MUI Paper. Paper's own rule sets `background-color:
    // background.paper` (#F8F8F8 light / #262626 dark), while ItemHeader's `topBar` wants
    // background.default (#fff / #212121) — a real difference, most visible in dark mode.
    //
    // Which one wins is decided by JSS injection order, and the library's styles and the app's
    // are injected from separate bundles. The portal's deleted fork of ItemHeader solved this
    // with `!important` on the background; the library's copy has no `!important`, which is the
    // only substantive difference between the two files.
    //
    // Restored here by SPECIFICITY rather than `!important`: `.backHeader .MuiPaper-root` is
    // (0,2,0) against Paper's (0,1,0), so it wins regardless of which bundle is injected first
    // — and without an `!important` that the next override would have to escalate past.
    '& .MuiPaper-root': {
      backgroundColor: theme.palette.background.default
    }
  },
  paper: { padding: theme.spacing(2) },
  // A `fieldset` carries a default border, margin and padding in every browser, so
  // wrapping the form in one would draw a box around the fields that was never part of
  // the design. Reset to nothing: the element is here for its `disabled` semantics
  // (which cascade to every descendant control natively), not for its appearance.
  //
  // `minWidth: 0` because fieldset has a UA-stylesheet `min-width: min-content` that
  // overrides the usual flex/grid shrink rules — without it a wide child stops the form
  // shrinking on narrow viewports. Same class of bug as the grid tracks in the list.
  fieldset: {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0
  },
  // Layout only. The colour and 0.75rem size this used to hardcode were MUI's `caption`
  // variant re-implemented by hand — the component now uses variant="caption" and picks
  // them up from the theme, so a future type-scale change reaches this label too.
  dateRangeLabel: {
    display: 'block',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5)
  },
  notice: { marginTop: theme.spacing(3) },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  }
}))
